

export const CHANGE_SECTION = "change/section";

export const GET_TASK_LOADING = 'get_task/loading'
export const GET_TASK_SUCCESS = 'get_task/success'
export const GET_TASK_ERROR = 'get_task/error'


export const ADD_TASK_LOADING = 'add_task/loading'
export const ADD_TASK_SUCCESS = 'add_task/success'
export const ADD_TASK_ERROR = 'add_task/error'

export const FILTER_ALL_TASK  = 'filter/open/all'

export const GET_PERSONAL_TASK_LOADING = 'get_personal_task/loading'
export const GET_PERSONAL_TASK_SUCCESS = 'get_personal_task/success'
export const GET_PERSONAL_TASK_ERROR = 'get_personal_task/error'

export const GET_PROFESSIONAL_TASK_LOADING = 'get_professionaltask/loading'
export const GET_PROFESSIONAL_TASK_SUCCESS = 'get_professionaltask/success'
export const GET_PROFESSIONAL_TASK_ERROR = 'get_professionaltask/error'

export const GET_OTHERS_TASK_LOADING = 'get_others_task/loading'
export const GET_OTHERS_TASK_SUCCESS = 'get_others_task/success'
export const GET_OTHERS_TASK_ERROR = 'get_others_task/error'

export const ADD_PROFESSIONAL_TASK_LOADING = 'add_professional_task/loading'
export const ADD_PROFESSIONAL_TASK_SUCCESS = 'add_professional_task/success'
export const ADD_PROFESSIONAL_TASK_ERROR = 'add_professional_task/error'

export const ADD_PERSONAL_TASK_LOADING = 'add_personal_task/loading'
export const ADD_PERSONAL_TASK_SUCCESS = 'add_personal_task/success'
export const ADD_PERSONAL_TASK_ERROR = 'add_personal_task/error'


export const ADD_OTHERS_TASK_LOADING = 'add_others_task/loading'
export const ADD_OTHERS_TASK_SUCCESS = 'add_others_task/success'
export const ADD_OTHERS_TASK_ERROR = 'add_others_task/error'


export const UPDATE_OTHERS_TASK_LOADING = 'update_others_task/loading'
export const UPDATE_OTHERS_TASK_SUCCESS = 'update_others_task/success'
export const UPDATE_OTHERS_TASK_ERROR = 'update_others_task/error'



export const UPDATE_PROFESSIONAL_TASK_LOADING = 'update_professional_task/loading'
export const UPDATE_PROFESSIONAL_TASK_SUCCESS = 'update_professional_task/success'
export const UPDATE_PROFESSIONAL_TASK_ERROR = 'update_professional_task/error'


export const UPDATE_PERSONAL_TASK_LOADING = 'update_personal_task/loading'
export const UPDATE_PERSONAL_TASK_SUCCESS = 'update_personal_task/success'
export const UPDATE_PERSONAL_TASK_ERROR = 'update_personal_task/error'


export const DELETE_OTHERS_TASK_LOADING = 'delete_others_task/loading'
export const DELETE_OTHERS_TASK_SUCCESS = 'delete_others_task/success'
export const DELETE_OTHERS_TASK_ERROR = 'delete_others_task/error'


export const DELETE_PROFESSIONAL_TASK_LOADING = 'delete_professional_task/loading'
export const DELETE_PROFESSIONAL_TASK_SUCCESS = 'delete_professional_task/success'
export const DELETE_PROFESSIONAL_TASK_ERROR = 'delete_professional_task/error'

export const DELETE_PERSONAL_TASK_LOADING = 'delete_personal_task/loading'
export const DELETE_PERSONAL_TASK_SUCCESS = 'delete_personal_task/success'
export const DELETE_PERSONAL_TASK_ERROR = 'delete_personal_task/error'


export const NOTES_CREATED = 'notes/created'
export const NOTES_UPDATED = 'notes/updated'
export const NOTES_DELETED = 'notes/deleted'
export const NOTES_READ = 'notes/read'

